import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';

import { Button } from 'components';
import { COPY_ICON_PATH } from 'constants/images.constants';
import { TranslationNamespace } from 'i18n';

type Props = {
  onClick: () => void;
  inline?: boolean;
};

export const CopyButton: React.FC<Props> = ({ onClick, inline }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_details',
  });

  return (
    <Button
      className={cx({
        'tw-inline tw-p-2 tw-mx-2 tw-mb-2 !tw-w-8 !tw-rounded-lg !tw-h-8 tw-relative':
          inline,
        'tw-flex tw-justify-center tw-items-center !tw-w-10 !tw-text-sm !tw-text-copy !tw-rounded-lg md:!tw-w-40 tw-mb-0 !tw-h-8':
          !inline,
      })}
      color="tertiary"
      onClick={onClick}
    >
      <SVG
        src={COPY_ICON_PATH}
        title="copy"
        className="tw-w-3.5 tw-h-3.5 md:tw-mr-3"
      />
      {!inline && (
        <div className="tw-hidden md:tw-block">{t('buttons.copy')}</div>
      )}
    </Button>
  );
};
